export const TIPO_MENU_PORTAL = {
    ITEM_MENU: 1,
    EXTERNO: 2,
    MODULO_FIXO: 3,
    MODULO_DINAMICO: 4,
    MODULO_ESPECIAL: 5,
  };